import React from "react";
import Card from "@/components/Card";
import { Box, Typography, SxProps, Tooltip } from "@mui/material";
import { StyledBadge } from "@/components/styled";
import SvgStatisticArrow from "@/assets/icons/SVGStatisticArrow";
import { getStatCardTooltipContent } from "../helpers/tooltipUtils";
import {
  getTrendColorConfig,
  getStatCardTooltipStyles,
} from "../helpers/utils";

interface StatCardProps {
  value: string | number;
  label: string;
  subtitle?: string;
  trend?: string;
  trendColor?: "green" | "red";
  sx?: SxProps;
  trendTooltip?: {
    description: string;
    comparisonPeriod: string;
  };
}

const StatCard: React.FC<StatCardProps> = ({
  value,
  label,
  subtitle,
  trend,
  trendColor,
  sx,
  trendTooltip,
}) => {
  try {
    const displayValue =
      value !== null && value !== undefined ? String(value) : "-";

    const { trendBg, trendText } = getTrendColorConfig(trendColor);
    const tooltipContent = getStatCardTooltipContent(trendTooltip, trend);

    return (
      <Card sx={sx}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Typography variant={"bodyHeader2"}>{displayValue}</Typography>
            {trend && (
              <Tooltip
                title={tooltipContent}
                arrow
                placement="top"
                componentsProps={{
                  tooltip: {
                    sx: getStatCardTooltipStyles(),
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    background: trendBg,
                    borderRadius: "6px",
                    px: 1,
                    py: 0.5,
                    cursor: tooltipContent ? "help" : "default",
                  }}
                >
                  <SvgStatisticArrow
                    color={trendText}
                    direction={trendColor === "red" ? "down" : "up"}
                  />
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 600,
                      color: trendText,
                      lineHeight: "16px",
                    }}
                  >
                    {trend}
                  </Typography>
                </Box>
              </Tooltip>
            )}
          </Box>
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#4E4B48",
              lineHeight: "20px",
            }}
          >
            {subtitle || label}
          </Typography>
        </Box>
      </Card>
    );
  } catch (error) {
    return (
      <Card sx={sx}>
        <Box sx={{ display: "flex", gap: "12px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <Typography variant={"bodyHeader2"} color="error">
              Error
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                color: "#4E4B48",
                lineHeight: "20px",
              }}
            >
              {subtitle || label}
            </Typography>
          </Box>
        </Box>
      </Card>
    );
  }
};

export default StatCard;
